<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <b-card id="main-card" no-body>
        <b-card-header>
          <i class="fa fa-list mr-2"></i>
          <strong>Gestion des équipes</strong>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col id="column-1" sm="3">
              <h4>Liste des utilisateurs non affectés</h4>
              <draggable
                v-model="users"
                class="list-group"
                tag="ul"
                v-bind="dragOptions"
                @start="isDragging = true"
                @end="changeList"
                :disabled="!canManage()">
                <transition-group type="transition" name="flip-list">
                  <li
                    class="list-group-item"
                    v-for="user in users"
                    :key="user.id"
                  >
                    {{user.nom}} {{user.prenom}} <br> <i class="text-primary">{{ user.libelle }}</i>
                  </li>
                </transition-group>
              </draggable>
            </b-col>
            <b-col id="column-2" sm="9">
              <b-row class="pb-2 align-right">
                <b-col sm="12">
                  <b-button type="button" class="float-right" size="md" variant="primary" v-b-modal.modal-equipe
                            v-if="canManage()">
                    <i class="fa fa-plus"></i> Ajouter une équipe
                  </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-card v-for="(equipe,key) in equipes" class="col-sm-4 card-equipe" sm="4" no-body :key="key">
                  <b-card-header v-bind:style="{ backgroundColor: equipe.couleur}">
                    {{equipe.libelle}}
                    <i :id="`tooltip-${key}`" class="fa fa-info clickable ml-2" v-if="equipe.description"></i>
                    <b-tooltip v-if="equipe.description" :target="`tooltip-${key}`" triggers="hover">
                      {{ equipe.description }}
                    </b-tooltip>
                    <span v-if="canManage()">
                      <i style="color: red;" id="tooltip-delete" class="fa fa-trash pull-right clickable"
                         @click="supprimer(equipe.id)"></i>
                      <b-tooltip target="tooltip-delete" triggers="hover">Supprimer équipe</b-tooltip>
                      <i id="tooltip-edit" class="fa fa-pencil pull-right clickable" @click="showEdit(equipe)"></i>
                      <b-tooltip target="tooltip-edit" triggers="hover">Modifier</b-tooltip>
                    </span>
                  </b-card-header>
                  <b-card-body v-bind:style="{ borderColor: equipe.couleur}">
                    <div class="drag-box drag-haut">
                      <div class="zone-title">Responsable</div>
                      <draggable
                        :ref="'zone-responsable-'+key"
                        v-model="equipe.responsable"
                        class="list-group zone"
                        tag="ul"
                        v-bind="dragOptions"
                        :sort="true"
                        @start="isDragging = true"
                        @end="changeList"
                        @change="responsableAjoute"
                        :disabled="equipe.responsable.length >= 1 || !canManage()">
                        <transition-group type="transition" name="flip-list">
                          <li
                            :ref="'li-responsable-'+responsable.id"
                            :id="getLiResponsableId(responsable)"
                            class="list-group-item"
                            v-for="(responsable, idx) in equipe.responsable"
                            :key="responsable.id"
                          >
                            {{responsable.nom}} {{responsable.prenom}} <br><span class="smaller text-primary">{{getLibelleProfil(responsable)}}</span>
                            <i class="fa fa-close close" @click="supprimerResponsable(key, idx)" v-if="canManage()"></i>
                          </li>
                        </transition-group>
                      </draggable>
                    </div>
                    <div class="drag-box drag-second">
                      <div class="zone-title">Equipe</div>
                      <draggable
                        style="min-height: 30px;"
                        v-model="equipe.gestionnaires"
                        class="list-group"
                        tag="ul"
                        v-bind="dragOptions"
                        :sort="true"
                        @start="isDragging = true"
                        @end="changeList"
                        @change="gestionnaireAjoute"
                        :disabled="!canManage()">
                        <transition-group type="transition" name="flip-list">
                          <li
                            class="list-group-item"
                            v-for="(gestionnaire, index) in equipe.gestionnaires"
                            :key="gestionnaire.id"
                          >
                            {{gestionnaire.nom}} {{gestionnaire.prenom}} <br><span class="smaller text-primary">{{getLibelleProfil(gestionnaire)}}</span>
                            <i class="fa fa-close close" @click="supprimerGestionnaire(gestionnaire, index, key)"
                               v-if="canManage()"></i>
                          </li>
                        </transition-group>
                      </draggable>
                    </div>
                  </b-card-body>
                </b-card>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>
    <b-modal ref="Equipemodal" id="modal-equipe">
      <template v-slot:modal-header>
        <h4> {{modalTitle}} </h4>
      </template>
      <b-form-group
        label="Libellé"
        label-for="libelle"
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="libelle" type="text" :class="{hasError: errors.libelle !== ''}"
                      v-model="libelleGroupToAdd"></b-form-input>
        <span class="field-error">{{ errors.libelle }}</span>
      </b-form-group>
      <b-form-group
        label='Ordre'
        label-for='ordre'
        :label-cols="3"
        :horizontal="true">
        <b-form-input id='ordre' type='number' min="0" v-model="ordre"></b-form-input>
      </b-form-group>
      <b-form-group
        label="Description"
        label-for='description'
        :label-cols="3"
        :horizontal="true">
        <b-form-textarea id="description" v-model="description"
                         placeholder="Entrer votre description"></b-form-textarea>
      </b-form-group>
      <chrome-picker v-model="colors" @input="updateValue" v-show="showColorPicker"/>
      <div id="colorPreview"></div>
      Couleur : <img @click="colorPicker()" id="colorPicker" src="@/assets/images/color_picker_icon_30.png">
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal()">Annuler</button>
          <button type="button" @click="save()" class="btn btn-primary">Valider</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from "@/utils/auth"
  import draggable from 'vuedraggable'
  import {hasRule, espaceGestionRules as rules} from "@/utils/rulesHelper"
  import {Chrome} from 'vue-color';
  import {isEmpty} from "../../utils/fileHelper";

  let colors = {
    hex: '#fcd5b5',
    hsl: {h: 27, s: 0.92, l: 0.85, a: 1},
    hsv: {h: 27, s: 0.92, v: 0.85, a: 1},
    rgba: {r: 252, g: 213, b: 181, a: 1},
    a: 1
  };

  export default {
    components: {
      draggable,
      'chrome-picker': Chrome
    },
    data() {
      return {
        selectedEquipeId: null,
        users: [],
        equipes: [],
        libelleGroupToAdd: '',
        libelles: [],
        descriptions: [],
        showColorPicker: false,
        couleur: '',
        ordre: '',
        description: '',
        modalTitle: 'Ajouter une équipe',
        colors,
        errors: {
          libelle: ''
        }
      }
    },
    mounted() {
      this.changeCardHeight()
      window.onresize = this.changeCardHeight
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: false,
          ghostClass: "ghost",
        };
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl()
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider()

      this.getEquipes()
    },
    methods: {
      changeCardHeight() {
        let mainCard = document.getElementById('main-card')
        let column1 = document.getElementById('column-1')
        let column2 = document.getElementById('column-2')
        mainCard.style.height = (window.innerHeight - 150) + 'px'
        column1.style.height = (window.innerHeight - 250) + 'px'
        column2.style.height = (window.innerHeight - 250) + 'px'
      },
      getEquipes() {
        let self = this
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .get('/espaceGestion/equipes')
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.equipes = response.data.equipes
            this.users = response.data.gestionnaires
            this.fillInput()
            this.sortUsers()
            this.sortGestionnaires()
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          })
      },
      getLiResponsableId(responsable) {
        return 'item-responsable-' + responsable.id
      },
      fillInput() {
        for (let key in this.equipes) {
          this.libelles[key] = this.equipes[key].libelle
        }
        for (let key in this.equipes) {
          this.descriptions[key] = this.equipes[key].description
        }
      },
      addEquipe() {
        if (this.validateData()) {
          let group = {}
          group.libelle = this.libelleGroupToAdd;
          group.ordre = this.ordre;
          group.description = this.description;
          group.couleur = this.colors.hex;
          group.responsable = []
          group.gestionnaires = []
          this.equipes.push(group)
          this.libelleGroupToAdd = ""
          this.$refs.Equipemodal.hide()
          this.storeEquipes()
          this.$swal({
            position: "top",
            type: "success",
            title: "Création avec succès",
            text: "L'équipe a été créée. ",
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      changeList() {
        this.storeEquipes()
      },
      storeEquipes() {
        let self = this;
        let config = {
          'equipes': this.equipes,
          'domaine': 'prestation'
        }
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .post("/espaceGestion/equipes/store", config).then(response => {
          this.$store.commit("IS_LOADING", false)
          this.equipes = response.data.equipes
          this.users = response.data.gestionnaires
          this.sortGestionnaires()
          this.fillInput()
        })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false)
            let errorText = "Une erreur est survenue, lors de l'enregistrement de l'equipe"
            if (error.response.status === 403) {
              errorText = "Vous n'êtes pas autorisé à effectuer cette action"
            }
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      editEquipe() {
        let self = this;
        let config = {
          'equipeId': this.selectedEquipeId,
          'libelle': this.libelleGroupToAdd,
          'description': this.description,
          'ordre': this.ordre,
          'couleur': this.colors.hex,
        }
        this.$store.commit("IS_LOADING", true)
        this.$axios
          .post("/espaceGestion/equipes/edit/" + this.selectedEquipeId, config)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.selectedEquipeId = null;
            this.$refs.Equipemodal.hide();
            this.modalTitle = "Ajouter une équipe";
            this.equipes = response.data.equipes
            this.users = response.data.gestionnaires
            this.fillInput();
          })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false)
            let errorText = "Une erreur est survenue, lors de l'enregistrement de l'equipe"
            if (error.response.status === 403) {
              errorText = "Vous n'êtes pas autorisé à effectuer cette action"
            }
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      showEdit(equipe) {
        this.selectedEquipeId = equipe.id;
        this.modalTitle = "Modifier une équipe";
        this.libelleGroupToAdd = equipe.libelle;
        this.ordre = equipe.ordre;
        this.description = equipe.description;
        this.colors.hex = equipe.couleur;
        this.$refs.Equipemodal.show();
      },
      responsableAjoute(evt) {
        this.users.push(evt.added.element)
        this.sortUsers()
        // this.storeEquipes()

        let li = document.getElementById('item-responsable-' + evt.added.element.id)
        let ul = li.parentNode.parentNode
        let div = ul.parentNode

        li.classList.add("full")
        ul.classList.add("full")
        div.classList.add("full")
      },
      gestionnaireAjoute(evt) {
        // this.storeEquipes()
        this.sortGestionnaires()
      },
      supprimer(equipeId) {
        let self = this;
        this.$swal
          .fire({
            title: "Attention !",
            text: "Êtes-vous sûr de vouloir supprimer la liste de l'équipe ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit("IS_LOADING", true)
              this.$axios
                .get("/espaceGestion/equipes/delete/" + equipeId).then(response => {
                this.$store.commit("IS_LOADING", false)
                // console.log(response)
                this.equipes = response.data.equipes
                this.users = response.data.gestionnaires
                this.fillInput()
              })
                .catch(function (error) {
                  self.$store.commit("IS_LOADING", false)
                  console.log(error.response.status)
                  let errorText = "Une erreur est survenue, lors de la suppression de l'equipe"
                  if (error.response.status === 403) {
                    errorText = "Vous n'êtes pas autorisé à effectuer cette action"
                  }
                  self.$swal({
                    position: "top",
                    type: "error",
                    title: "Attention !!",
                    text: errorText,
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })
      },
      supprimerGestionnaire(element, idx, key) {
        this.equipes[key].gestionnaires.splice(idx, 1)
       /* let gestionnaireInUser = false;
        this.users.forEach(user => {
          if(user.id === element.id){
            gestionnaireInUser = true;
          }
        });
        if(gestionnaireInUser === false){
         // this.users.push(element)
        }*/
        this.storeEquipes()
      },
      supprimerResponsable(key, index) {
        // console.log(this.equipes[key])
        this.equipes[key].responsable.splice(index, 1)
        this.storeEquipes()
        // this.equipes[key].responsable = []
      },
      closeModal() {
        this.selectedEquipeId = null;
        this.$refs.Equipemodal.hide();
        this.modalTitle = "Ajouter une équipe";
        this.libelleGroupToAdd = "";
        this.ordre = "";
        this.description = "";
        this.colors.hex = "#fcd5b5";
      },
      sortGestionnaires() {
        this.equipes.map((equipe) => {
          equipe.gestionnaires = equipe.gestionnaires.sort((a, b) => {
            if (a.nom < b.nom) {
              return -1
            } else if (a.nom > b.nom) {
              return 1
            } else {
              return 0
            }
          })
        })
      },
      getLibelleProfil(user) {
        return user.profil_active[0] !== undefined ? user.profil_active[0].libelle : 'Pas de profil rattaché';
      },
      sortUsers() {
        this.users = this.users.sort((a, b) => {
          if (a.nom < b.nom) {
            return -1
          } else if (a.nom > b.nom) {
            return 1
          } else {
            return 0
          }
          // return a.ordre - b.ordre
        })
      },
      validateData() {
        this.clearErrors()
        let valid = true
        if (this.libelleGroupToAdd === "") {
          this.errors.libelle = "Le libellé est obligatoire"
          valid = false
        }

        return valid
      },
      clearErrors() {
        this.errors.libelle = ""
      },
      canManage() {
        return hasRule(rules.MANAGE_ADMIN_EQUIPES)
      },
      updateValue() {
        let preview = document.getElementById('colorPreview')
        preview.style.backgroundColor = this.colors.hex
      },
      colorPicker() {
        this.showColorPicker = !this.showColorPicker;
        if (this.showColorPicker) {
          let colorWheel = document.getElementById('colorPicker')
          let posWheel = colorWheel.getBoundingClientRect()
          let colorPicker = document.getElementsByClassName('vc-chrome')[0]
          let posColorPicker = colorPicker.getBoundingClientRect()
          colorPicker.style.top = '-242px';
          colorPicker.style.left = (posWheel.x - 462) + 'px'
        }
      },
      save() {
        if (isEmpty(this.selectedEquipeId)) {
          this.addEquipe();
        } else {
          this.editEquipe();
        }
      }
    }
  }
</script>

<style>
  #main-card {
    height: 700px;
  }

  #column-1 {
    height: 600px;
    overflow: auto;
  }

  #column-2 {
    height: 600px;
    overflow: auto;
  }

  .zone {
    min-height: 3em;
  }

  .close {
    float: right;
    font-weight: normal;
    font-size: 0.8em;
  }

  .zone-title {
    width: 100%;
    font-size: 0.9em;
    font-weight: bold;
    text-align: center;
    background-color: #EFEFEF;
  }

  .full:hover {
    cursor: not-allowed;
  }

  .card-equipe .card-body {
    border: 1px solid #BFBFBF;
  }

  .card {
    border: none;
  }
</style>
